(function () {
    // Variables globales
    const productVariants = CurrentProduct;
    const templateName = CurrentTemplate;
    const selectedOptions = { magsafe: null };
    const getUrl = window.location;
    const variantMagSafeEls = document.querySelectorAll('.variant_magsafe');
    const magsafeSelectedEl = document.querySelector('.magsafe-selected');
    const productSelectEl = document.querySelector('#ProductSelect');
    const addToCartBtn = document.querySelector('#AddToCartBtnBsl');
  
    // Funtions
    async function addToCartClickHandler(event) {
      const bodyElement = document.querySelector('body');
      const drawerCart = document.querySelector('#drawer-cart-modal')
      event.preventDefault();
      const form = event.target.parentNode;
      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        await response.json();
        bodyElement.style.overflow = 'hidden';
        drawerCart.classList.add('show-cart-modal');
        liquidAjaxCart.update();
        
      } catch (error) {
        console.log(error);
      }
    }

    function toggleShopPayVisibility(isAvailable) {
      const paymentButton = document.querySelector('.shopify-payment-button');
      const shopPayContainer = document.querySelector('.shop-pay-contianer');
      const toggleAction = isAvailable ? 'remove' : 'add';

      if (paymentButton) paymentButton.classList[toggleAction]('dn-i');
      if (shopPayContainer) shopPayContainer.classList[toggleAction]('dn-i');
    }

    function getSelectedVariantById() {
      if (!productSelectEl) return null;
      const selectedId = productSelectEl.value;
      return productVariants.variants.find(variant => String(variant.id) === String(selectedId));
    }
      
    function handleClick(event) {
      event.preventDefault();
  
      event.preventDefault();
  
      const button = event.currentTarget;
    
      const optionName = button.getAttribute('data-name');
      const optionValue = button.getAttribute('value');
      const onlyLeftInStock = document.querySelector('#only-left-in-stock');
      selectedOptions[optionName] = optionValue;
  
      const selectedVariant = getProductVariant(productVariants, selectedOptions);
      
      console.log('Selected options:', selectedOptions);
      console.log('Selected variant:', selectedVariant);
  
      addRemoveClass(`.variant_${optionName}`, button, 'selected');
      updateSizeAvailability();
      if (selectedVariant) {
        magsafeSelectedEl.textContent = selectedVariant.title || 'N/A';
        productSelectEl.value = selectedVariant.id;

        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);

        if (
          typeof selectedVariant.inventory_management !== 'undefined' &&
          selectedVariant.inventory_management &&
          selectedVariant.inventory_quantity > 0 &&
          selectedVariant.inventory_quantity <= 10
        ) {
          onlyLeftInStock && onlyLeftInStock.classList.add('show-only-left');
          onlyLeftInStock && onlyLeftInStock.classList.remove('dn-i');
          if (onlyLeftInStock != null) onlyLeftInStock.textContent = `Only ${selectedVariant.inventory_quantity} left!`;
        } else {
          onlyLeftInStock && onlyLeftInStock.classList.add('dn-i', 'show-only-left');
        }

        const variantUrl = getUrl.search.split('nosto=').pop();
        if (!variantUrl) {
          history.pushState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        }

        const soldButton = document.querySelector('.sold-out-btn');
        const backInStock = document.querySelector('.pdp-klaviyo-trigger');
        let showRealPrice = document.querySelectorAll('.info-product-detail__pdp-price');

        if (selectedVariant.available) {
          UpdatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
          let showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');

          if (selectedVariant.compare_at_price > selectedVariant.price) {
            UpdatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);
            [...showComparePrice].forEach(item => item.classList.remove('dn-i'));
            [...showRealPrice].forEach(item => item.classList.add('fc-red-lt'));
          } else {
            [...showComparePrice].forEach(item => item.classList.add('dn-i'));
            [...showRealPrice].forEach(item => item.classList.remove('fc-red-lt'));
          }

          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('dn-i');
          addToCartBtn.classList.remove('disabled-add-to-cart');
          soldButton.classList.add('dn-i');
          backInStock.classList.add('dn-i');
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('disabled-add-to-cart');
          soldButton.classList.remove('dn-i');
          backInStock.classList.remove('dn-i');
          addToCartBtn.classList.add('dn-i');
          [...showRealPrice].forEach(item => item.classList.remove('fc-red-lt'));
        }

        toggleShopPayVisibility(selectedVariant.available);
      }
    }
  
    function getProductVariant(product, selectedOptions) {
      const magsafeSelected = selectedOptions.magsafe;
      
      console.log('Looking for variant with title:', magsafeSelected);
      console.log('Available variants:', product.variants.map(v => v.title));
      
      // Find variant by title match
      const selectedVariant = product.variants.find(variant => variant.title === magsafeSelected);
      
      if (selectedVariant) {
        UpdatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
        let showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');
  
        if (selectedVariant.compare_at_price > selectedVariant.price) {
            UpdatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);  
            [...showComparePrice].forEach(item => item.classList.remove('dn-i'));
        }else{
            [...showComparePrice].forEach(item => item.classList.add('dn-i'));
        }
      }
        
      return selectedVariant;
    }
  
    function setDefaultVariant() {
      const variantUrl = getUrl.search.split('?variant=').pop();
      const selectedOptions = document.querySelectorAll('.swatch-btn[selected]');
      const availableVariants = productSelectEl.querySelectorAll('option');
  
      if (variantUrl && [...availableVariants].some(v => v.value === variantUrl)) {
        productSelectEl.value = variantUrl;
        document.querySelector('.variant_magsafe.selected') && document.querySelector('.variant_magsafe.selected').click();
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${variantUrl}`);
      }
      if (selectedOptions) selectedOptions.forEach(option => option.click());
  
    }
  
    //Availables variants magsafe
    function updateSizeAvailability() {
      // Update MagSafe availability
      variantMagSafeEls.forEach(magsafeEl => {
        const magsafeValue = magsafeEl.getAttribute('value');
        const variant = productVariants.variants.find(v => v.title === magsafeValue);
  
        if (variant && variant.available) {
          magsafeEl.classList.remove('sold-out');
        } else {
          magsafeEl.classList.add('sold-out');
        }
      });
    }

    function initProductVariants() {
      variantMagSafeEls.forEach(variantMagSafeEl => variantMagSafeEl.addEventListener('click', handleClick));
    }
  

    //Render Gallerty tags
    function renderGalleryTags() {
      const tagsContainers = Array.from(document.getElementsByClassName('image-gallery-tag'));
      
      tagsContainers.forEach(tagEle => {
          tagEle.addEventListener('click', () => {

            const tagButton =  tagEle.querySelector('.image-gallery-tag__icon');
            const tagText = tagEle.querySelector('.image-gallery-tag__text');    
                tagButton.classList.toggle('hide-elem')
                tagText.classList.toggle('hide-elem')
          });
      });


    }
    function accordions() {
      const accordion = document.querySelectorAll('.accordion-pdp');
      [...accordion].forEach((singleAccordion, index) => {
        singleAccordion.addEventListener('click', () => {
          singleAccordion.classList.toggle('active-pdp');
          const panel = singleAccordion.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }

        });
      });
    }
  //Helpers
  function removeFadeInClass(timestamp, element) {
    let startTime = null;
    const duration = 500; // Delay duration in milliseconds
    if (!startTime) {
      startTime = timestamp;
    }

    const elapsed = timestamp - startTime;

    if (elapsed < duration) {
      requestAnimationFrame((timestamp) => {
        removeFadeInClass(timestamp, element);
      });
    } else {
      element.classList.remove('fade-in');
    }
  }

    function addRemoveClass(optionName, selected, active) {
      let container = document.querySelectorAll(optionName);
      [...container].forEach(item => {
        item.classList.remove(active);
      });
      selected.classList.add(active)
    }
    function UpdatePriceVariant(items, price) {
      let container = document.querySelectorAll(items);

      [...container].forEach(item => {
        return item.innerHTML = `${window.currencySymbol}${(price / 100).toFixed(2)}`;
      });
    }
    function cutTheTextContent(textContent) {
      var decimal = /^[+-]?\d+(\.\d+)?$/;
      if (textContent.includes('/')) return textContent;
      if (textContent.includes('$')) return textContent.slice(0, -3);
      if (decimal.test(textContent)) return textContent;
      return textContent.replace(/[^A-Z]/g, '')
    }
  
    function removeAccordionEmpty() {
      [...document.querySelectorAll('.accordion-content')].forEach(item => {
        if ([...item.children].length == 0) {
          item.classList.add('dn-i')
        }
      })
    }
  
    if (!addToCartBtn) return;
  
    initProductVariants();
  
    setDefaultVariant();
    const initialVariant = getSelectedVariantById();
    if (initialVariant) toggleShopPayVisibility(initialVariant.available);
    accordions();
    renderGalleryTags()
    removeAccordionEmpty();

    addToCartBtn.addEventListener('click', addToCartClickHandler);
  

  })();

  function UdapteContainerIfHeaderSticky(params) {
    let headerDiv = document.querySelector('#header');
    let stickyContainer = document.querySelector('.main-container-pdp .info-container')
    
    if (headerDiv.classList.contains('stuck') && headerDiv.classList.contains('tuck') && headerDiv.classList.contains('untuck')){
      stickyContainer.style.top = '115px';
    }else{
      stickyContainer.style.top = '5px';
    }

  }

  document.addEventListener("scroll", UdapteContainerIfHeaderSticky);

  //utility functions
  function waitForElement(selector) {
    return new Promise(resolve => {
      const element = document.querySelector(selector);
      if (element) {
        return resolve(element);
      }
      
      const observer = new MutationObserver(mutations => {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
          observer.disconnect();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
  
  function renderYotpoRatingCount() {
    let yotpoRatings = document.querySelectorAll('.card-related-product__content-rating .yotpo-bottomline .text-m');
      
    [...yotpoRatings].forEach(rating => {
      let cutTextRating = rating.getAttribute('aria-label').split(' ').shift();
          rating.textContent = `(${cutTextRating})`;
    })
  }

  waitForElement('.standalone-bottomline .yotpo-stars').then((elm) => {
    setTimeout(renderYotpoRatingCount, 2000); 
  });


  //modal size 
  function openCloseModalG(modal, action) {
    const sizeChart = document.querySelector(modal);
    if (action) sizeChart.classList.add('size-chart-show')
    if (!action) sizeChart.classList.remove('size-chart-show')
  }
  
  
  function hideElementOnEsc(elementSelector, keyCode, classNameToAdd, isAdd, carousel) {
    const element = document.querySelector(elementSelector);
  
    if (!element) {
      console.error(`Element not found with selector: ${elementSelector}`);
      return;
    }
  
    document.addEventListener('keydown', function (event) {
      if (event.keyCode === keyCode) {
        if (!element.classList.contains(classNameToAdd && isAdd)) {
          if (isAdd) element.classList.add(classNameToAdd);
          document.querySelector('body').style.overflow = 'auto';
        }
  
        if (element.classList.contains(classNameToAdd) && !isAdd) {
          element.classList.remove(classNameToAdd);
          document.querySelector('body').style.overflow = 'auto';
          if ($(carousel).hasClass('slick-initialized')) {
            $(carousel).slick('unslick');
          }
        }
  
      }
    });
  }
  
  waitForElement('.container-infinite').then((elm) => {
    hideElementOnEsc('.container-infinite', 27, 'dn-i', true);
  });

  waitForElement('.zoom-gallery_container').then((elm) => {
    hideElementOnEsc('.zoom-gallery_container', 27, 'dn-i', true);
  });
  
  waitForElement('.size-chart-acf__modal').then((elm) => {
    hideElementOnEsc('.size-chart-acf__modal', 27, 'dn-i', true);

  });
